import React, { Component } from "react";
import Slider from "react-slick";
// import { baseUrl } from "./config";
import FirstImage from '../assets/images/slider2fristimage.jpg'
import SecImage from '../assets/images/slider2secimage.jpg'
import ThirdImage from '../assets/images/slider2Thirdimage.jpg'

export default class LazyLoad extends Component {
  render() {
    const settings = {
      //   dots: true,
      lazyLoad: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 2
    };
    return (
      <div className="slider2-child">
        {/* <h2> Lazy Load</h2> */}
        <Slider {...settings}>

          <div>
            <div className="slider2img-parent">
              <img src={FirstImage} style={{ width: '416px', height: '284px' }} alt="subhi" />

              <div className="slider2-text">
                <div>
                  <h2><span>Find the perfect car </span>
                    <span style={{ color: '#593cfb' }}>for scenic corners & curves</span>
                  </h2>
                  <p>Get your fill of high-performance thrills, with the richest selection of luxury and exotic vehicles anywhere.</p>
                  <button className="browseBtn">Browse Cars</button>
                </div>

              </div>
            </div>
          </div>

          <div>
            <div className="slider2img-parent">
              <img src={SecImage} style={{ width: '416px', height: '284px' }} alt="subhi" />
              <div className="slider2-text">
                <div>
                  <h2><span>Find the perfect car </span>
                    <span style={{ color: '#593cfb' }}>for scenic corners & curves</span>
                  </h2>
                  <p>Get your fill of high-performance thrills, with the richest selection of luxury and exotic vehicles anywhere.</p>
                  <button className="browseBtn">Browse Cars</button>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="slider2img-parent">
              <img src={ThirdImage} style={{ width: '416px', height: '284px' }} alt="subhi" />
              <div className="slider2-text">
                <div>
                  <h2><span>Find the perfect car </span>
                    <span style={{ color: '#593cfb' }}>for scenic corners & curves</span>
                  </h2>
                  <p>Get your fill of high-performance thrills, with the richest selection of luxury and exotic vehicles anywhere.</p>
                  <button className="browseBtn">Browse Cars</button>
                </div>
              </div>
            </div>
          </div>

        </Slider>
      </div>
    );
  }
}